import { Typography } from "antd";
import { ReactComponent as CheckSelectIcon } from "../../../common/images/svg/CheckSelect.svg";
import "./option.css";

const CurrencyOption = ({
  currencyOption,
  setOpenOption,
  setCurrencyOption,
}: {
  currencyOption: string;
  setOpenOption: React.Dispatch<React.SetStateAction<boolean>>;
  setCurrencyOption: React.Dispatch<React.SetStateAction<string>>;
}) => {
  return (
    <div className={"option-setting"}>
      <div
        className="text-setting"
        onClick={() => {
          setCurrencyOption("USD"), setOpenOption(false);
        }}
      >
        <Typography
          style={{
            fontSize: 14,
            fontWeight: 400,
            color: currencyOption === "USD" ? "#1DABF1" : "white",
          }}
        >
          USD
        </Typography>
        {currencyOption === "USD" && <CheckSelectIcon />}
      </div>
      <div
        className="text-setting"
        onClick={() => {
          setCurrencyOption("EUR"), setOpenOption(false);
        }}
      >
        <Typography
          style={{
            fontSize: 14,
            fontWeight: 400,
            color: currencyOption === "EUR" ? "#1DABF1" : "white",
          }}
        >
          EUR
        </Typography>
        {currencyOption === "EUR" && <CheckSelectIcon />}
      </div>
    </div>
  );
};
export default CurrencyOption;
